'use client';
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import Prev from '@/src/components/common/ui/buttons/Prev.jsx';
import Next from '@/src/components/common/ui/buttons/Next.jsx';
import CloseButtonYgen from '@/src/components/common/ui/buttons/CloseButtonYgen.jsx';
import { Col, Container, Row } from 'react-bootstrap';
import { Img } from '@/src/components/common/ui/images/Img.jsx';
import reactHtmlParser from 'react-html-parser';
import { StyledBlogList } from '@/src/components/common/eco/sections/modal-slider/modal-slider.style.js';

const BlogList = ({ data,  onclick, show, people, pdf, product }) => {
	const nextRef = useRef()
	const prevRef = useRef()
	const section_data = data?.section_data;
	const image_data = data?.images?.list || data?.images;

	const bannerimage = image_data?.list;
	const handleClick = useCallback(() => {
		if (onclick) {
			onclick();
		}
	}, [onclick]);

	const swiperBreakpoints = useMemo(() => ({
		320: {
			slidesPerView: 1,
			spaceBetween: 15,
		},
		768: {
			slidesPerView: 3,
			spaceBetween: 15
		},
		1024: {
			slidesPerView: 4,
			spaceBetween: 15

		},
	}));

	const [numPages, setNumPages] = useState();
	const [pageNumber, setPageNumber] = useState(1);


	const onDocumentLoadSuccess = (numPages) => {
		setNumPages(numPages);
	}
	const items = data?.list || (Array.isArray(data) ? data : []);
	const shouldCenter = items.length > 3;

	console.log(shouldCenter, 'ok')
	return (
		<StyledBlogList className={pdf ? 'pdf' : ''} data-lenis-prevent>
			<div className="close-button-ygen" onClick={handleClick}>
				<CloseButtonYgen active={show} color="#152637" />
			</div>
			<Container>
				<Row>

					{
						people ?

							<>
								<Col md={4}>
									<div className="image-wrapper" >
										<Img src={data?.images?.[0]?.full_path} alt={data?.data?.title || 'Member Image'} />
									</div>
								</Col>
								<Col md={{span: 7, offset: 1}}>
									<div className="content">
										<div className="info">
											<p>{reactHtmlParser(data?.data?.subtitle)}</p>
											<p>{reactHtmlParser(data?.data?.short_desc)}</p>
										</div>
										<div className="content-inner">
											{reactHtmlParser(data?.data?.description)}
										</div>
									</div>
								</Col>
							</>

							:

							pdf ?
								<>
									<iframe
										className={'pdf-viewer'}
										src={data}
										width="100%"
										height="100%"
										title="PDF Viewer"
										frameBorder="0"
									/>
								</>

								:


								<Col md={12} className={shouldCenter === false > 3 ? 'center-slider' : ''}>
									<Swiper
										Swiper modules={[Autoplay, Pagination, Navigation]}
										allowTouchMove={true}
										slidesPerView={4}
										spaceBetween={15}
										autoplay={false}
										speed={800}
										navigation={{
											prevEl: '.prev_swipper',
											nextEl: '.next_swipper',
										}}
										loop={true}
										breakpoints={swiperBreakpoints}

									>
										{
											data?.list && data?.list?.length > 0 &&
											data?.list?.map((e, index) => {
												return (
													<SwiperSlide key={index}>
														<div className="image-blog-wrapper">
															<img loading="lazy" src={e?.full_path} alt={e?.short_title} />
														</div>
													</SwiperSlide>
												);
											})
										}


										{
											data && data?.length > 0 &&
											data?.map((e, index) => {
												return (
													<SwiperSlide key={index}>
														<div className="image-blog-wrapper">
															<img loading="lazy" src={e?.full_path} alt={e?.short_title} />
														</div>
													</SwiperSlide>
												);
											})
										}


									</Swiper>
									<ul className={'navigation_item'}>
										<li className={'prev_swipper'} ref={prevRef}>
											<Prev background={'#152637'} color={'white'} />
										</li>
										<li className={'next_swipper'} ref={nextRef}>
											<Next background={'#152637'} color={'white'} />
										</li>
									</ul>
								</Col>

					}

				</Row>
			</Container>
		</StyledBlogList>
	);
};


export default BlogList;
